<template>

    <v-chip
            :color="option.color"
            outlined
            @mouseover="toggleText(true)" @mouseout="toggleText(false)">
        <v-icon left>{{ option.icon }}</v-icon>
        <v-fade-transition leave-absolute>
            <span v-if="!hideText || textVisible"> {{ option.text }}</span>
        </v-fade-transition>
    </v-chip>

</template>

<script>
export default {
    props: {
        option: Object,
        hideText: {
            type: [Boolean, String],
            default: function(){
                return false;
            }
        }
    },
    data(){
        return {
            textVisible: false
        };
    },
    methods: {
        toggleText(state){
            this.textVisible = state;
        }
    }
}
</script>

<style scoped>
.v-chip{
    border-radius: 0 !important;
}
</style>